
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nse024ab0e57873a842172a3c2d5c3fa66en from './en.yaml'
            i18n.addResourceBundle('en', 'e024ab0e57873a842172a3c2d5c3fa66', flattenObject(nse024ab0e57873a842172a3c2d5c3fa66en), true, true);
        
        export default 'e024ab0e57873a842172a3c2d5c3fa66';
    